import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

export const adminPageShellSx = {
  p: { xs: 1, sm: 2, md: 3 },
  pt: { xs: 8, sm: 2, md: 3 },
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
};


/**
 * AdminPageHeader - Intestazione pagina admin:
 * titolo + descrizione a sinistra, `centerActions` (es. pulsanti di pagina)
 * impilati e centrati in mezzo, azioni (ricerca/filtri) a destra.
 * Non e' sticky: scorre con la pagina. La ricerca sticky su mobile va gestita
 * nella pagina come elemento fratello (contenitore alto quanto la tabella).
 */
const AdminPageHeader = ({ title, subtitle, actions, centerActions }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        mb: { xs: 3, md: 4 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "stretch", md: "center" },
        justifyContent: "space-between",
        gap: { xs: 2, md: 3 },
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant={isMobile ? "h5" : "h4"}
          sx={{ fontWeight: 800, letterSpacing: "-0.02em", color: "#0b3d87", lineHeight: 1.15 }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ mt: 0.75, color: "#64748b", fontWeight: 500 }}>
            {subtitle}
          </Typography>
        )}
        <Box
          sx={{
            mt: 1.5,
            width: 56,
            height: 4,
            borderRadius: 999,
            background: "linear-gradient(90deg, #0b3d87 0%, #345ea3 100%)",
          }}
        />
      </Box>

      {centerActions && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
            flex: { md: 1 },
            width: { xs: "100%", md: "auto" },
          }}
        >
          {centerActions}
        </Box>
      )}

      {actions && (
        <Box sx={{ flexShrink: 0, width: { xs: "100%", md: "auto" } }}>{actions}</Box>
      )}
    </Box>
  );
};

AdminPageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
  centerActions: PropTypes.node,
};

export default AdminPageHeader;
